import { render, staticRenderFns } from "./sliderDetails.vue?vue&type=template&id=6f911ee0"
import script from "./sliderDetails.vue?vue&type=script&lang=js"
export * from "./sliderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports